










































































































































import Vue from 'vue'

export default Vue.extend({
  data() {
    return {
      menuIsOpen: false,
    }
  },
  watch: {
    menuIsOpen(nowIs: boolean, wasBefore: boolean) {
      const body = document.body
      if (nowIs && !wasBefore) {
        body.classList.add('overlay-open')
      }
      if (!nowIs && wasBefore) {
        body.classList.remove('overlay-open')
      }
    },
  },
})
